import { Configuration } from '@azure/msal-browser';

// Azure AD MSAL Configuration (from env)
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MICROSOFT_TENANT_ID || 'organizations'}`,
    redirectUri: process.env.REACT_APP_MICROSOFT_REDIRECT_URI || window.location.origin + '/callback',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

// Azure AD login request scopes
// Use openid for ID token (contains user info)
// The ID token's aud will be our client ID
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

// Auth0 Configuration (from env)
export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || '',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || '',
  audience: process.env.REACT_APP_AUTH0_AUDIENCE || '',
  redirectUri: process.env.REACT_APP_AUTH0_REDIRECT_URI || '',
};
